import React from 'react';
import { contact } from '../data/products';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-column">
            <div className="footer-logo">
              <svg width="50" height="38" viewBox="0 0 194 145" fill="none">
                <path d="M144.477 47.5932C140.209 40.7414 134.26 35.0943 127.195 31.1883C120.131 27.2823 112.185 25.247 104.112 25.2757C77.9063 25.2757 56.6304 46.4267 56.6304 72.4939C56.6304 98.5611 77.9063 119.712 104.112 119.712C112.869 119.72 121.457 117.305 128.926 112.735C136.396 108.165 142.455 101.618 146.435 93.8185H121.875C115.69 93.8333 109.752 91.3923 105.366 87.032C100.979 82.6716 98.503 76.7484 98.481 70.5635H176.863V72.5078C176.852 86.4051 172.832 100.004 165.284 111.673C157.736 123.342 146.982 132.585 134.311 138.294H134.228C134.152 138.294 134.075 138.37 133.999 138.37C84.003 160.146 20.4181 110.998 0.621204 144.752C-4.30199 59.1756 58.7413 15.7834 58.7413 15.7834C73.5006 4.09321 92.2043 -1.44551 110.949 0.323137C129.694 2.09179 147.032 11.0312 159.344 25.2757C171.78 12.8323 172.641 0.236135 172.641 0.236135C172.641 0.236135 188.362 1.31938 193.917 8.70764C177.648 40.1286 144.477 47.5932 144.477 47.5932Z" fill="url(#paint0_linear_footer)"/>
                <defs>
                  <linearGradient id="paint0_linear_footer" x1="0" y1="80.5" x2="194" y2="79.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FA6030"/>
                    <stop offset="1" stopColor="#FFC876"/>
                  </linearGradient>
                </defs>
              </svg>
              <div className="logo-text">
                <span className="logo-main">GPO</span>
                <span className="logo-sub">GREEN POWER ORIENTED</span>
              </div>
            </div>
            <p className="footer-description">
              {t(translations.footer.description)}
            </p>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">{t(translations.footer.officeItaly)}</h4>
            <ul className="footer-list">
              <li>
                <span className="list-icon">{'\u{1F4CD}'}</span>
                <span>{t(contact.address)}</span>
              </li>
              <li>
                <span className="list-icon">{'\u{1F4DE}'}</span>
                <a href={`tel:${contact.phone}`}>{contact.phone}</a>
              </li>
              <li>
                <span className="list-icon">{'\u{1F4E7}'}</span>
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </li>
              <li>
                <span className="list-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </span>
                <a href={contact.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">{t(translations.footer.manufacturer)}</h4>
            <ul className="footer-list">
              <li><strong>GPO OÜ</strong></li>
              <li>{t({ it: 'Produttore europeo', ru: 'Европейский производитель' })}</li>
              <li>{t({ it: 'Qualità certificata CE', ru: 'Сертифицировано CE' })}</li>
              <li>VAT: {contact.company.vat}</li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">{t(translations.footer.advantages)}</h4>
            <ul className="footer-list">
              {translations.footer.advantagesList.map((advantage, index) => (
                <li key={index}>{'\u2713'} {t(advantage)}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            {t(translations.footer.copyright)} {'\u{1F9E1}'}
          </p>
          <div className="footer-links">
            {translations.footer.bottomLinks.map((link, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span>{'\u2022'}</span>}
                <span>{t(link)}</span>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
